import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import ReactPaginate from 'react-paginate';
import moment from 'moment';

import SysadminUserUserUploadUserExcel from '../../component/sysadmin/user/upload_user_excel';
import SysadminUserUserUploadUserTable from '../../component/sysadmin/user/upload_user_table';
import SysadminUserUserUploadUserResults from '../../component/sysadmin/user/upload_user_results';
import SysadminUserUploadUserFlatFile from '../../component/sysadmin/user/upload_user_flat_file';
import {
    submitSystemAdminCreateUsersUpload,    
} from '../../actions';
import { Button, Segment } from 'semantic-ui-react';

const POLICY_NO_SMU = ['2100653158', '2100653765'];
const ACTION_STATUS_TERMINATE = 'T';
const ACTION_STATUS_CHANGE = 'C';
const ACTION_STATUS_ADD = 'A';

class SysadminUsersPage extends Component {
    state = {
        step: 1,
        newUsers: null,
        isSubmitting: false,
        results: null,
        fileUploadName: undefined,
        perPage: 1,
        pageCount: 1,
        currentPage: 0,
    }

    submitNewUsersToCreate = () => {
        let isOk = window.confirm("Are you sure you want to submit all data?");
        if(isOk){
            this.setState({
                isSubmitting: true,
                results: null
            });
            this.props.submitSystemAdminCreateUsersUpload({
                accessToken: this.props.user.accessToken,
                data: {
                    newUsers: this.state.newUsers,
                    filename: this.state.fileUploadName
                }
            }, (result, error) => {
                if (result) {
                    this.setState({isSubmitting: false, results: result.results, step: 3});
                }else{
                    this.setState({isSubmitting: false, results: null, error:error, step: 4});
                }
            });
        }
    }

    processNewExcelData = (rawUsersData) => {
        const remapValuesToField = [
            null,
            null,
            null,
            "companyName",
            "actionType",
            "name",
            "nric",
            "birthdate",
            "gender",
            "designation",
            "planNo",
            "staffId",
            "costCenter",
            "effectiveStartDate",
            "effectiveEndDate",
            "newNric",
            "dep_name",
            "dep_nric",
            "dep_birthdate",
            "dep_gender",
            "dep_relationship",
            "dep_planNo",
            "dep_effectiveStartDate",
            "dep_effectiveEndDate",
            "dep_newNric",
            "changeEffectiveDate",
            "bankName",
            "bankCode",
            "branchCode",
            "accountNo",
            "email"
        ];
        let newUsersArray = [];
        for (let i = 0; i < rawUsersData.length; i++) {
            let rawUserData = rawUsersData[i];
            let newUserObj = {};
            for (let y = 0; y < rawUserData.length; y++) {
                const fieldName = remapValuesToField[y]
                if (fieldName) {
                    newUserObj[fieldName] = (rawUserData[y]) ? rawUserData[y].trim() : rawUserData[y];
                }
            }
            if (!newUserObj.email) {
                newUserObj.email = `temp_${newUserObj.nric}@groupcareincome.com.sg`.toLowerCase();
            }
            newUsersArray.push(newUserObj);
        }
        this.setState({
            step: this.state.step + 1,
            newUsers: newUsersArray,
            pageCount: Math.ceil(newUsersArray.length / this.state.perPage),
        });
    }

    processNewFlatFileData = (rawUsersData) => {
        const remapValuesToField = [
            "companyCode",
            "companyName",
            "name",
            "nric",
            "birthdate",
            "gender",
            "staffId",
            "costCenter",
            "effectiveStartDate",
            "effectiveEndDate",
            "designation",
            "dep_name",
            "dep_relationship",
            "dep_nric",
            "dep_birthdate",
            "planNo",
            "bankNo",
            "branchNo",
            "accountNo",
            "newNric",
            "dep_newNric",
            "changeEffectiveDate",
            "costCentreName",
            "loginRequired"
        ];
        let newUsersArray = [];
        for (let i = 0; i < rawUsersData.length; i++) {
            let rawUserData = rawUsersData[i];
            let newUserObj = {};
            for (let y = 0; y < rawUserData.length; y++) {
                const fieldName = remapValuesToField[y]
                if (fieldName) {
                    newUserObj[fieldName] = (rawUserData[y]) ? rawUserData[y].trim() : rawUserData[y];
                }
            }
            if (newUserObj.nric) {
                newUserObj.nric = newUserObj.nric.toLowerCase();
            }
            if (!newUserObj.email) {
                newUserObj.email = `temp_${newUserObj.nric}@groupcareincome.com.sg`.toLowerCase();
            }
            newUsersArray.push(newUserObj);
        }
        let combinedNewUsersObject = {};
        for (let i = 0; i < newUsersArray.length; i++) {
            let newUserData = newUsersArray[i];
            if (newUserData.dep_nric) {
                const newDependentObj = {
                    name: newUserData.dep_name,
                    nric: newUserData.dep_nric.toLowerCase(),
                    birthdate: newUserData.dep_birthdate,
                    // gender: newUserData.dep_nric,
                    relationship: newUserData.dep_relationship,
                    planNo: newUserData.planNo,
                    effectiveStartDate: newUserData.effectiveStartDate,
                    effectiveEndDate: newUserData.effectiveEndDate,
                    loginRequired: newUserData.loginRequired,
                    email: `temp_${newUserData.dep_nric}@groupcareincome.com.sg`.toLowerCase(),
                };
                if (combinedNewUsersObject[newUserData.nric]) {
                    combinedNewUsersObject[newUserData.nric].family.push(newDependentObj);
                } else {
                    newUserData.family = [];
                    combinedNewUsersObject[newUserData.nric] = newUserData;
                    combinedNewUsersObject[newUserData.nric].family.push(newDependentObj);
                }
            } else {
                if (combinedNewUsersObject[newUserData.nric]) {
                    const currentFamily = combinedNewUsersObject[newUserData.nric].family;
                    newUserData.family = currentFamily;
                    combinedNewUsersObject[newUserData.nric] = newUserData;

                } else {
                    newUserData.family = [];
                    combinedNewUsersObject[newUserData.nric] = newUserData;
                }
            }
        }
        // console.log('combinedNewUsersObject', combinedNewUsersObject);
        // convert object back to array
        const convertedCombinedNewUsersArray = _.values(combinedNewUsersObject);
        // console.log('convertedCombinedNewUsersArray', convertedCombinedNewUsersArray);
        // this.setState({step: this.state.step + 1, newUsers: newUsersArray});
        this.setState({
            step: this.state.step + 1,
            newUsers: convertedCombinedNewUsersArray,
            pageCount: Math.ceil(convertedCombinedNewUsersArray.length / this.state.perPage),
        });
    }

    _convertDateToTimestamp(date, dateFormat='DD-MMM-YYYY'){
        try{
            let momemntDate = moment(date, dateFormat, true);
            if(momemntDate.isValid()){
                return momemntDate.valueOf();
            }else{
                return "Invalid Date";
            }
        }catch(err){
            return "Invalid Date";
        }
    }

    processNewFlatFileDataSMU = (file, rawUsersData) => {
        const remapValuesToField = [
            "companyCode",
            "companyName",
            "name",
            "nric",
            "birthdate",
            "gender",
            "staffId",
            "costCenter",
            "effectiveStartDate",
            "effectiveEndDate",
            "designation",
            "dep_name",
            "dep_relationship",
            "dep_nric",
            "dep_birthdate",
            "planNo",
            "bankNo",
            "branchNo",
            "accountNo",
            "newNric",
            "dep_newNric",
            "changeEffectiveDate",
            "costCenterName",
            "loginRequired",
            "studentFullBankAccountNo",
            "studentEmail",
            "studentTel",
            "studentCareerCode",
            "reserved",
            "studentMaritalStatus",
            "reserved",
            "reserved",
            "studentID",
            "studentNationality",
            "singaporeCitizenshipstatus",
            "nsMenIndicator",
            "actionStatus"
        ];
        let newUsersArray = [];
        for (let i = 0; i < rawUsersData.length; i++) {
            let rawUserData = rawUsersData[i];
            // console.log("rawUserData", rawUserData);
            let newUserObj = {};
            for (let y = 0; y < rawUserData.length; y++) {
                const fieldName = remapValuesToField[y]
                // console.log("fieldName", fieldName);
                if (fieldName) {
                    newUserObj[fieldName] = (rawUserData[y]) ? rawUserData[y].trim() : rawUserData[y];
                }
            }
            if (newUserObj.nric) {
                newUserObj.nric = newUserObj.nric.toLowerCase();
            }
            if (newUserObj.studentID) {
                newUserObj.studentID = newUserObj.studentID.toLowerCase();
            }

            // Populate email
            if (newUserObj.studentEmail) {
                newUserObj.studentEmail = newUserObj.studentEmail.toLowerCase();
                newUserObj.email = newUserObj.studentEmail;
            }

            // Remove studentEmail if not under SMU
            if (!POLICY_NO_SMU.includes(newUserObj.companyCode)) {
                newUserObj.studentEmail = null;
            }

            if (newUserObj.birthdate) {
                newUserObj.birthdate = this._convertDateToTimestamp(newUserObj.birthdate);
            }
            if (newUserObj.effectiveStartDate) {
                newUserObj.effectiveStartDate = this._convertDateToTimestamp(newUserObj.effectiveStartDate);
            }
            if (newUserObj.effectiveEndDate) {
                newUserObj.effectiveEndDate = this._convertDateToTimestamp(newUserObj.effectiveEndDate);
            }
            if (newUserObj.changeEffectiveDate) {
                newUserObj.changeEffectiveDate = this._convertDateToTimestamp(newUserObj.changeEffectiveDate);
            }
            if (newUserObj.dep_birthdate) {
                newUserObj.dep_birthdate = this._convertDateToTimestamp(newUserObj.dep_birthdate);
            }
            
            newUsersArray.push(newUserObj);
        }
        let combinedNewUsersObject = {};
        for (let i = 0; i < newUsersArray.length; i++) {
            let flatData = newUsersArray[i];

            // Define required user data
            let userData = {
                nric: flatData.nric,
                isUserMustExist: true
            }

            // Define required company data
            let companyData = {
                companyCode: flatData.companyCode,
            }

            // Handle dependent data
            if (flatData.dep_nric) {
                const dependentData = {
                    nric: flatData.dep_nric.toLowerCase(),
                };

                // Add optional data
                if(flatData.dep_newNric) dependentData.newDependentNric = flatData.dep_newNric;
                if(flatData.dep_name) dependentData.name = flatData.dep_name;
                if(flatData.gender) dependentData.gender = flatData.gender;
                if(flatData.email) dependentData.email = flatData.email;
                if(flatData.dep_birthdate) dependentData.birthdate = flatData.dep_birthdate;
                if(flatData.dep_relationship) dependentData.relationship = flatData.dep_relationship;
                if(flatData.effectiveStartDate) dependentData.effectiveStartDate = flatData.effectiveStartDate;
                if(flatData.loginRequired) dependentData.loginRequired = flatData.loginRequired;
                if(flatData.planNo) dependentData.planNo = flatData.planNo;
                dependentData.effectiveEndDate = flatData.effectiveEndDate;

                // Add data for SMU User
                if(POLICY_NO_SMU.includes(companyData.companyCode)){
                    if(flatData.studentFullBankAccountNo) dependentData.studentFullBankAccountNo = flatData.studentFullBankAccountNo;
                    if(flatData.studentEmail) dependentData.studentEmail = flatData.studentEmail;
                    if(flatData.studentTel) dependentData.studentTel = flatData.studentTel;
                    if(flatData.studentCareerCode) dependentData.studentCareerCode = flatData.studentCareerCode;
                    if(flatData.studentMaritalStatus) dependentData.studentMaritalStatus = flatData.studentMaritalStatus;
                    if(flatData.studentID) dependentData.studentID = flatData.studentID;
                    if(flatData.studentNationality) dependentData.studentNationality = flatData.studentNationality;
                    if(flatData.singaporeCitizenshipstatus) dependentData.singaporeCitizenshipstatus = flatData.singaporeCitizenshipstatus;
                    if(flatData.nsMenIndicator) dependentData.nsMenIndicator = flatData.nsMenIndicator;
                }

                // Add dependent to existing user
                if (combinedNewUsersObject[userData.nric]) {
                    // Get existing user
                    let existingUser = combinedNewUsersObject[userData.nric];
                    // Get existing company
                    let existingCompany = existingUser.companies.find( data => data.companyCode === companyData.companyCode );
                    // Add dependent
                    if(existingCompany){
                        existingCompany.family.push(dependentData);
                    }else{
                        companyData.family = [dependentData]
                        existingUser.companies.push(companyData);
                    }
                } 
                // Add dependent to new user
                else {
                    // Set user family data
                    companyData.family = [dependentData];
                    // Set user companies data
                    userData.companies = [companyData];
                    // Add user to final result
                    combinedNewUsersObject[userData.nric] = userData;
                }
            }

            // Handle user data
            else{

                // Set user optional data
                userData.isUserMustExist = false;
                if(flatData.newNric) userData.newNric = flatData.newNric;
                if(flatData.name) userData.name = flatData.name;
                if(flatData.gender) userData.gender = flatData.gender;
                if(flatData.bankNo) userData.bankNo = flatData.bankNo;
                if(flatData.branchNo) userData.branchNo = flatData.branchNo;
                if(flatData.accountNo) userData.accountNo = flatData.accountNo;
                if(flatData.loginRequired) userData.loginRequired = flatData.loginRequired;
                if(flatData.email) userData.email = flatData.email;
                if(flatData.birthdate) userData.birthdate = flatData.birthdate;

                // Set user data for SMU User
                if(POLICY_NO_SMU.includes(companyData.companyCode)){
                    if(flatData.studentFullBankAccountNo) userData.studentFullBankAccountNo = flatData.studentFullBankAccountNo;
                    if(flatData.studentEmail) userData.studentEmail = flatData.studentEmail;
                    if(flatData.studentTel) userData.studentTel = flatData.studentTel;
                    if(flatData.studentCareerCode) userData.studentCareerCode = flatData.studentCareerCode;
                    if(flatData.studentMaritalStatus) userData.studentMaritalStatus = flatData.studentMaritalStatus;
                    if(flatData.studentID) userData.studentID = flatData.studentID;
                    if(flatData.studentNationality) userData.studentNationality = flatData.studentNationality;
                    if(flatData.singaporeCitizenshipstatus) userData.singaporeCitizenshipstatus = flatData.singaporeCitizenshipstatus;
                    if(flatData.nsMenIndicator) userData.nsMenIndicator = flatData.nsMenIndicator;
                }

                // Set company data
                if(flatData.companyName) companyData.companyName = flatData.companyName;
                if(flatData.effectiveStartDate) companyData.effectiveStartDate = flatData.effectiveStartDate;
                if(flatData.memberType) companyData.memberType = flatData.memberType;
                if(flatData.designation) companyData.designation = flatData.designation;
                if(flatData.planNo) companyData.planNo = flatData.planNo;
                if(flatData.staffId) companyData.staffId = flatData.staffId;
                if(flatData.costCenter) companyData.costCenter = flatData.costCenter;
                if(flatData.costCentreName || flatData.costCenterName) companyData.costCenterName = flatData.costCentreName || flatData.costCenterName;
                companyData.effectiveEndDate = flatData.effectiveEndDate;
                
                // Handle new user
                if(!combinedNewUsersObject[userData.nric]){
                    // Set user family data
                    companyData.family = [];
                    // Set user companies data
                    userData.companies = [companyData];
                    // Add user to final result
                    combinedNewUsersObject[userData.nric] = userData;
                }

                // Handle existing user
                else{
                    let existingUser = combinedNewUsersObject[userData.nric];

                    // Find existing company
                    let existingCompany = existingUser.companies.find( data => data.companyCode === companyData.companyCode );

                    // Set Companies
                    if(existingCompany){
                        for(let key in companyData){
                            existingCompany[key] = companyData[key];
                        }
                    }else{
                        companyData.family = [];
                        existingUser.companies.push(companyData);
                    }

                    // Set existing user data
                    combinedNewUsersObject[userData.nric] = {...existingUser, ...userData};
                } 
            }
        }

        // console.log('combinedNewUsersObject', combinedNewUsersObject);
        // convert object back to array
        const convertedCombinedNewUsersArray = _.values(combinedNewUsersObject);
        // console.log('convertedCombinedNewUsersArray', convertedCombinedNewUsersArray);
        // this.setState({step: this.state.step + 1, newUsers: newUsersArray});
        this.setState({
            step: this.state.step + 1,
            newUsers: convertedCombinedNewUsersArray,
            fileUploadName: file.name,
            pageCount: Math.ceil(convertedCombinedNewUsersArray.length / this.state.perPage),
        });
    }

    handlePageClick = data => {
        console.log('data', data)
        this.setState({
            currentPage: data.selected
        })
        window.scrollTo(0, 0)
    };

    render() {

        let newUsers = []
        let totalUser = 0;
        let totalDependent = 0;
        if (this.state.newUsers) {
            newUsers = this.state.newUsers.slice((this.state.currentPage * this.state.perPage), (this.state.currentPage * this.state.perPage + this.state.perPage))
            for(let user of this.state.newUsers){
                // Count total User
                if(!user.isUserMustExist){
                    totalUser += 1;
                }
                // Count total Dependent
                if(Array.isArray(user.companies)){
                    for(let comp of user.companies){
                        if(Array.isArray(comp.family)){
                            totalDependent += comp.family.length;
                        }
                    }
                }
            }
        }

        return (
            <div>
                { (this.state.step === 1) ?
                  (
                  <SysadminUserUploadUserFlatFile processNewFlatFileData={ this.processNewFlatFileDataSMU } />
                  )
                  :
                  null }
                { (this.state.step === 2) ?
                  <>
                    <p>
                        <strong>Total Employees :</strong>
                        <span>{" "+totalUser+" users"}</span>
                    </p>
                    <p style={{marginBottom:"0"}}>
                        <strong>Total Dependent :</strong>
                        <span>{" "+totalDependent+" dependents"}</span>
                    </p>

                    <ReactPaginate
                        previousLabel={ 'Previous' }
                        nextLabel={ 'Next' }
                        breakLabel={ '...' }
                        breakClassName={ 'break-me' }
                        pageCount={ this.state.pageCount }
                        marginPagesDisplayed={ 2 }
                        pageRangeDisplayed={ 5 }
                        onPageChange={ this.handlePageClick }
                        containerClassName={ 'pagination' }
                        subContainerClassName={ 'pages pagination' }
                        activeClassName={ 'active' }
                        forcePage={ this.state.currentPage}
                    />

                    <SysadminUserUserUploadUserTable
                        newUsers={ newUsers }
                        submitNewUsersToCreate={ this.submitNewUsersToCreate }
                        isSubmitting={ this.state.isSubmitting } 
                    />

                    <ReactPaginate
                        previousLabel={ 'Previous' }
                        nextLabel={ 'Next' }
                        breakLabel={ '...' }
                        breakClassName={ 'break-me' }
                        pageCount={ this.state.pageCount }
                        marginPagesDisplayed={ 2 }
                        pageRangeDisplayed={ 5 }
                        onPageChange={ this.handlePageClick }
                        containerClassName={ 'pagination' }
                        subContainerClassName={ 'pages pagination' }
                        activeClassName={ 'active' } 
                        forcePage={ this.state.currentPage}
                    />

                    <Button color='green' fluid loading={this.state.isSubmitting} disabled={this.state.isSubmitting} onClick={this.submitNewUsersToCreate} attached='top' size='big'>
                        {`Submit All Data (${totalUser} Users and ${totalDependent} Dependents)`}
                    </Button>
                  </>
                  :
                  null }

                 { this.state.step === 3 && 
                    <Segment style={{textAlign:"center"}}>
                        <p>We are processing your file.</p>
                        <p>Please check the upload status under 'Job' tab.</p>
                    </Segment>
                }
            </div>
            );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user
    }
}

export default connect(mapStateToProps, {
    submitSystemAdminCreateUsersUpload,
})(SysadminUsersPage);
